<template>
  <Content class="contact-us">
    <Card dis-hover>
      <googlemaps-map ref="map" class="map" :center.sync="center" :zoom.sync="zoom">
        <!-- User Position -->
        <googlemaps-user-position @update:position="setUserPosition" />
        <!-- Marker -->
        <googlemaps-marker
          title="Pro Finance Home"
          :draggable="false"
          :position="{ lat: 42.646799568012, lng: 21.149711608887 }"
        />
        <!-- Polyline -->
      </googlemaps-map>
    </Card>
  </Content>
</template>
<script>
export default {
  data() {
    return {
      center: {
        lat: 42.646799568012,
        lng: 21.149711608887,
      },
      path: [
        {
          lat: 48.853,
          lng: 2.298,
        },
        {
          lat: 48.8735,
          lng: 2.2951,
        },
      ],
      options: {},
      userPosition: null,
      zoom: 13,
    };
  },
  methods: {
    setUserPosition(position) {
      this.userPosition = position;
    },
  },
};
</script>


<style lang="scss">
.contact-us {
  margin: 20px 0;
  display: flex;
  height: 100%;
  flex-direction: column;
  .ivu-card {
    .ivu-card-body {
      height: 100%;
    }
    // flex: 1 1 100%;
    .map {
      min-height: 500px;
    }
    .ivu-card {
      margin-top: 15px;
    }
  }
}
</style>
